/* eslint-disable */
// @ts-nocheck

import { kkBridgeHasMethod } from './jsBridge';

/*
 * @Description:
 * @Author: pengjin
 * @Date: 2022-09-22 18:36:35
 * @LastEditors: pengjin
 * @LastEditTime: 2022-09-22 18:36:36
 */
/* eslint-disable */
// @ts-nocheck
export function sensorsTrack(server_url: string) {
  (function (para) {
    const p = para.sdk_url;
    const n = para.name;
    const w = window;
    const d = document;
    const s = 'script';
    let x = null;
    let y = null;
    w.sensorsDataAnalytic201505 = n;
    w[n] =
      w[n] ||
      function (a: any) {
        return function () {
          (w[n]._q = w[n]._q || []).push([a, arguments]);
        };
      };
    const ifs = [
      'track',
      'quick',
      'register',
      'registerPage',
      'registerOnce',
      'trackSignup',
      'trackAbtest',
      'setProfile',
      'setOnceProfile',
      'appendProfile',
      'incrementProfile',
      'deleteProfile',
      'unsetProfile',
      'identify',
      'login',
      'logout',
      'trackLink',
      'clearAllRegister',
      'getAppStatus',
      'use',
    ];
    for (let i = 0; i < ifs.length; i++) {
      w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
    if (!w[n]._t) {
      (x = d.createElement(s)), (y = d.getElementsByTagName(s)[0]);
      x.async = 1;
      x.src = p;
      x.setAttribute('charset', 'UTF-8');
      y.parentNode.insertBefore(x, y);
      w[n].para = para;
    }
    console.log(server_url, 'server_url');
  })({
    sdk_url: '//static.sensorsdata.cn/sdk/1.25.10/sensorsdata.min.js?newVersion=1',
    heatmap_url: '//static.sensorsdata.cn/sdk/1.25.10/heatmap.min.js',
    name: 'sensors',
    // show_log: true,
    show_log: false,
    // 是否在Crefit中，在的话才开启app-web模式
    app_js_bridge: kkBridgeHasMethod('kk_closeWindow'),
    // debug_mode: true, //开启debug模式 暂时关掉
    // debug_mode_upload:false,//true不入库使用debug数据查看 false入库使用导入中的数据查看
    server_url,
    send_type: 'beacon',
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: 'default',
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: 'default',
      // 可视化埋点支持采集的元素
      collect_tags: {
        div: {
          max_level: 3, // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
        },
        img: true,
        svg: true,
        span: true,
      },
    },
    max_string_length: 1024,
  });
}
